var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CButton',{attrs:{"size":_vm.size,"disabled":_vm.disabled,"bg":"buttonSecondary","color":"breadcrumbNotActive2","_hover":{ bg: 'buttonSecondary' }}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }